.logoParent {
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 39px;
  left: 0;
  margin: auto;
  right: 0;
}

.returnsWealth {
  width: 102.70992279052734;
  height: 27.878406524658203;
  top: -2.23px;
  gap: 5.95px;
}

@media (max-width: 720px) {
  .returnsWealthLogo {
    width: 195;
    height: 25.305343627929688;
    top: 39px;
    left: 97px;
  }
}
